"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterPenalized = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ButtonTs = _interopRequireDefault(require("../../../../../ButtonTs"));
var _HotelCardTag = _interopRequireDefault(require("../../../../../HotelCardTag/HotelCardTag"));
var _XMark = _interopRequireDefault(require("../../../../../../icons-react/rebrand/XMark"));
/**
 * Примененный фильтр на поиске, выводится для пустой выдачи
 */
var FilterPenalized = exports.FilterPenalized = function FilterPenalized(props) {
  var isMobile = props.isMobile,
    filter = props.filter,
    onChangeFilter = props.onChangeFilter;
  var filterName = filter.filterName,
    diff = filter.diff,
    filterGroupLabel = filter.filterGroupLabel,
    filterValue = filter.filterValue;
  var fullName = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isMobile && /*#__PURE__*/_react["default"].createElement("span", null, filterGroupLabel), !isMobile && filterValue && /*#__PURE__*/_react["default"].createElement("span", null, ": "), /*#__PURE__*/_react["default"].createElement("span", null, filterValue));
  var handleClick = function handleClick(e) {
    if (!onChangeFilter) return;
    e.stopPropagation();
    onChangeFilter({
      path: filterName,
      diff: diff
    });
  };
  return onChangeFilter ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    offHover: true,
    size: "flex",
    onClick: handleClick,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement("span", null, fullName), /*#__PURE__*/_react["default"].createElement(CloseIcon, null)) : /*#__PURE__*/_react["default"].createElement(_HotelCardTag["default"], {
    type: "filterPenalized",
    text: fullName
  });
};
var StyledButton = (0, _styledComponents["default"])(_ButtonTs["default"]).withConfig({
  displayName: "FilterPenalized__StyledButton",
  componentId: "sc-1jvc1e5-0"
})(["padding:6px 10px 6px 12px;min-height:28px;display:flex;align-items:center;justify-content:center;color:var(--black);font-size:14px;font-style:normal;font-weight:400;line-height:16px;", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && "\n      max-width: 220px;\n  ";
});
var CloseIcon = (0, _styledComponents["default"])(_XMark["default"]).withConfig({
  displayName: "FilterPenalized__CloseIcon",
  componentId: "sc-1jvc1e5-1"
})(["height:16px;margin-left:4px;flex-shrink:0;& path{fill:var(--grey1);}"]);